<template>
  <div>
    <Loader v-if="homePageLoading" />
    <!-- The page is no longer gated on homePageLoading.
         It used to be: this wrapper carried v-show="!homePageLoading" and the
         hero and slider each carried v-if="!homePageLoading" on top of that, so
         nothing at all was on screen until the flag flipped. Nothing was being
         waited FOR, though — loadHomePageConfig() makes no network call, so the
         flag was held purely by a hardcoded setTimeout of 600ms. Every section
         below is static content that is ready the moment this component mounts.

         Keeping the hero behind v-if was the most expensive part: it holds the
         page's LCP element (div.mea-pattern in MainSection), so the largest
         thing on the page could not exist for 600ms after an already-slow
         mount. -->
    <div>
      <div class="lines-wrap">
          <div class="lines-inner">
            <div class="lines"></div>
          </div>
        </div>

        <!-- Each section is handed its own block of assets/home-content.json.
             The sections also default to the same block when the prop is left
             off, which is what lets Header, PatnersView and FooterView keep
             working unchanged on the pages that use them without this view. -->
        <HomeHeader :content="content.HomeHeader" />

        <HomeMainSection :content="content.HomeMainSection" />

        <HomePatnerViews :content="content.HomePatnerViews" />
        <HomeServicesView :content="content.HomeServicesView" />
        <HomeSliderSection :content="content.HomeSliderSection" />

        <HomeFooterView :content="content.HomeFooterView" />

        <!-- <HomeFeatureSection /> -->
        <!-- <HomeStepsView /> -->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Loader from "@/components/Loader.vue";
import HomeHeader from "@/components/HomeViewSection/Header.vue";
import HomeMainSection from "../components/HomeViewSection/MainSection.vue";
import HomeFeatureSection from "../components/HomeViewSection/FeatureSection.vue";
import HomePatnerViews from "../components/HomeViewSection/PatnersView.vue";
import HomeServicesView from "../components/HomeViewSection/ServicesView.vue";
import HomeSliderSection from "../components/HomeViewSection/SliderSection.vue";
import HomeStepsView from "../components/HomeViewSection/StepsView.vue";
import HomeFooterView from "../components/HomeViewSection/FooterView.vue";
import { initAOS, refreshAOS } from "@/utils/aos";
// The page's copy, images and links. Imported rather than fetched: webpack
// inlines it into the bundle, so there is no request to wait on and no state
// where the page is mounted but its text has not arrived.
import homeContent from "@/assets/home-content.json";

// The longest the loading overlay may stay up once this view has mounted.
// It is a ceiling, not a duration: the overlay is normally released on the
// first frame after mount, and this only exists so a slow render cannot leave
// it on screen indefinitely.
const LOADER_MAX_MS = 200;

export default {
  name: "HomeView",
  components: {
    Loader,
    HomeHeader,
    HomeMainSection,
    HomeFeatureSection,
    HomePatnerViews,
    HomeServicesView,
    HomeSliderSection,
    HomeStepsView,
    HomeFooterView
  },
  data() {
    return {
      content: homeContent,
      projectDetails: {},
      isHomeView: true,
      homePageLoading: true,
      // Timer handle for the ceiling above, cleared on unmount.
      loaderCap: null
    };
  },

  mounted() {
    // Not awaited any more, because there is nothing to await.
    // loadHomePageConfig() is declared async but contains no network call: it
    // assigns a hardcoded projectDetails object, sets isHomeView, and schedules
    // AOS.init plus the jQuery menu wiring on the next tick. `await` on it only
    // ever cost a microtask, and the 600ms setTimeout that followed was pure
    // delay in front of content that was already rendered.
    this.loadHomePageConfig();

    // Release the overlay as soon as the sections are actually on screen.
    // nextTick puts us after Vue has patched the DOM; the extra frame lets the
    // browser paint that DOM before the overlay fades, so the handoff is
    // content-to-content rather than overlay-to-blank.
    this.$nextTick(() => {
      requestAnimationFrame(() => {
        this.homePageLoading = false;
      });
    });

    // Hard ceiling. The line above is what normally drops the overlay; this
    // guarantees it can never outstay LOADER_MAX_MS even if a render is slow
    // or a frame is dropped.
    this.loaderCap = setTimeout(() => {
      this.homePageLoading = false;
    }, LOADER_MAX_MS);
  },

  beforeUnmount() {
    // Navigating away before the ceiling fires would otherwise leave a timer
    // writing to a destroyed instance.
    clearTimeout(this.loaderCap);
  },
  methods: {
    // async waitForAllImages() {
    //   const images = Array.from(document.images); // Get all images in the component
    //   const totalImages = images.length;

    //   if (totalImages === 0) {
    //     this.homePageLoading = true;
    //     return;
    //   }

    //   let loadedCount = 0;

    //   const markLoaded = () => {
    //     loadedCount++;
    //     if (loadedCount === totalImages) {
    //       this.homePageLoading = true;
    //     }
    //   };

    //   images.forEach(img => {
    //     if (img.complete) {
    //       markLoaded();
    //     } else {
    //       img.addEventListener("load", markLoaded);
    //       img.addEventListener("error", markLoaded); // still count failures
    //     }
    //   });
    // },
    handleImageLoad() {
      this.isLoaded = true; // hide loader, show banner
    },
    async waitForAllImages() {
      const images = Array.from(document.images);
      console.log("Images found:", images.length);
      console.log(images);

      const totalImages = images.length;

      if (totalImages === 0) {
        console.log("No images found → hiding loader");
        this.homePageLoading = true;
        return;
      }

      let loadedCount = 0;

      const markLoaded = (event) => {
        loadedCount++;
        // console.log("Loaded:", loadedCount, "/", totalImages, event.target.src);

        if (loadedCount === totalImages) {
          // console.log("ALL LOADED!");
          this.homePageLoading = false;
        }
      };

      images.forEach(img => {
        if (img.complete) {
          // console.log("Already cached:", img.src);
          markLoaded({ target: img });
        } else {
          img.addEventListener("load", markLoaded);
          img.addEventListener("error", markLoaded);
        }
      });
    },
    async loadHomePageConfig() {
      $(function () {

        'use strict';

        $(".loader").delay(200).fadeOut("slow");
        $("#overlayer").delay(200).fadeOut("slow");
      })
      this.projectDetails = {
        CREATORID: "19043000000004004",
        MODIFIEDTIME: "2025-07-10 19:24:13:526",
        ProjectName: "Tata Play Fiber",
        CREATEDTIME: "2025-07-10 19:24:13:526",
        ROWID: "19043000000554002",
        ProjectDescription:
          "This software is a comprehensive customer and service management system specifically tailored for Tata Play Fiber. It leverages Zoho’s suite of tools—such as Zoho CRM, Zoho Desk, Zoho Creator, and Zoho Books—to efficiently manage customer relationships, service requests, and broadband plans.",
        ProjectLogo: "19043000000560135",
        ProjectTagline:
          "Complete Software Solution for Tata Play Fiber Using Zoho CRM, Zoho Desk, etc.",
        ProjectVideoDemo: "19043000000560160",
      };
      if (this.$route.path !== "/") {
        this.isHomeView = false;
      } else {
        this.isHomeView = true;
      }
      this.$nextTick(() => {
        // Was an inline copy of the settings with easing: "slide", which is
        // not an AOS easing - it fell back to linear. Shared now, so every
        // entrance on the site runs on the same curve.
        initAOS();

        // Trigger AOS refresh after short delay to fix non-triggering issue
        setTimeout(() => {
          refreshAOS();
        }, 500);
        // =========================
        // Loader Fade Effects
        // =========================
        $(".loader").delay(400).fadeOut("slow");
        $("#overlayer").delay(200).fadeOut("slow");

        // =========================
        // Site Menu Clone & Mobile Menu Toggle
        // =========================
        const siteMenuClone = () => {
          $(".js-clone-nav").each(function () {
            const $this = $(this);
            $this
              .clone()
              .attr("class", "site-nav-wrap")
              .appendTo(".site-mobile-menu-body");
          });

          setTimeout(() => {
            let counter = 0;
            $(".site-mobile-menu .has-children").each(function () {
              const $this = $(this);
              $this.prepend('<span class="arrow-collapse collapsed">');
              $this.find(".arrow-collapse").attr({
                "data-toggle": "collapse",
                "data-target": "#collapseItem" + counter,
              });
              $this.find("> ul").attr({
                class: "collapse",
                id: "collapseItem" + counter,
              });
              counter++;
            });
          }, 1000);

          $("body").on("click", ".arrow-collapse", function (e) {
            const $this = $(this);
            $this
              .toggleClass("active", !$this.closest("li").find(".collapse").hasClass("show"));
            e.preventDefault();
          });

          $(window).resize(function () {
            const w = $(this).width();
            if (w > 768 && $("body").hasClass("offcanvas-menu")) {
              $("body").removeClass("offcanvas-menu");
            }
          });

          $("body").on("click", ".js-menu-toggle", function (e) {
            e.preventDefault();
            $("body").toggleClass("offcanvas-menu");
            $("body").find(".js-menu-toggle").toggleClass("active");
          });

          // Click outside offcanvas
          $(document).mouseup(function (e) {
            const container = $(".site-mobile-menu");
            if (!container.is(e.target) && container.has(e.target).length === 0) {
              $("body").removeClass("offcanvas-menu");
              $("body").find(".js-menu-toggle").removeClass("active");
            }
          });
        };
        siteMenuClone();

        // =========================
        // Owl Carousel Plugin
        // =========================
        const owlPlugin = () => {
          if ($(".owl-2-slider").length) {
            const owl2 = $(".owl-2-slider").owlCarousel({
              loop: true,
              autoHeight: true,
              margin: 40,
              autoplay: true,
              smartSpeed: 700,
              items: 2,
              nav: true,
              dots: true,
              navText: [
                '<span class="icon-keyboard_backspace"></span>',
                '<span class="icon-keyboard_backspace"></span>',
              ],
              responsive: {
                0: { items: 1 },
                600: { items: 1 },
                800: { items: 2 },
                1000: { items: 2 },
                1100: { items: 2 },
              },
            });
            $(".js-custom-next-v2").click(e => {
              e.preventDefault();
              owl2.trigger("next.owl.carousel");
            });
            $(".js-custom-prev-v2").click(e => {
              e.preventDefault();
              owl2.trigger("prev.owl.carousel");
            });
          }

          if ($(".owl-3-slider").length) {
            $(".owl-3-slider").owlCarousel({
              loop: true,
              autoHeight: true,
              margin: 40,
              autoplay: true,
              smartSpeed: 700,
              items: 4,
              nav: true,
              dots: true,
              navText: [
                '<span class="icon-keyboard_backspace"></span>',
                '<span class="icon-keyboard_backspace"></span>',
              ],
              responsive: {
                0: { items: 1 },
                600: { items: 1 },
                800: { items: 2 },
                1000: { items: 2 },
                1100: { items: 3 },
              },
            });
          }

          if ($(".owl-4-slider").length) {
            $(".owl-4-slider").owlCarousel({
              loop: true,
              autoHeight: true,
              margin: 10,
              autoplay: true,
              smartSpeed: 700,
              items: 4,
              dots: true,
              responsive: {
                0: { items: 1 },
                600: { items: 2 },
                800: { items: 2 },
                1000: { items: 3 },
                1100: { items: 4 },
              },
            });
          }

          if ($(".owl-single-text").length) {
            $(".owl-single-text").owlCarousel({
              loop: true,
              autoHeight: true,
              margin: 0,
              autoplay: true,
              smartSpeed: 1200,
              items: 1,
              nav: false,
            });
          }

          if ($(".owl-single").length) {
            const owl = $(".owl-single").owlCarousel({
              loop: true,
              autoHeight: true,
              autoplay: true,
              smartSpeed: 800,
              mouseDrag: false,
              touchDrag: false,
              items: 1,
              nav: false,
              onChanged: changed,
            });

            function changed(event) {
              let i = event.item.index || 1;
              i = i - 1;
              $(".js-custom-dots a").removeClass("active");
              $(`.js-custom-dots a[data-index="${i}"]`).addClass("active");
            }

            $(".js-custom-dots a").each(function (i) {
              $(this).attr("data-index", i + 1);
            });

            $(".js-custom-dots a").on("click", function (e) {
              e.preventDefault();
              owl.trigger("stop.owl.autoplay");
              const k = $(this).data("index") - 1;
              owl.trigger("to.owl.carousel", [k, 500]);
            });
          }
        };
        owlPlugin();

        // =========================
        // One Page Smooth Scroll
        // =========================
        const OnePageNavigation = () => {
          $("body").on(
            "click",
            ".site-nav .site-menu li a[href^='#'], .smoothscroll[href^='#'], .site-mobile-menu .site-nav-wrap li a",
            function (e) {
              e.preventDefault();
              const hash = this.hash;
              $("html, body").animate(
                { scrollTop: $(hash).offset().top },
                400,
                "easeInOutExpo",
                () => {
                  window.location.hash = hash;
                }
              );
            }
          );
        };
        OnePageNavigation();

        // =========================
        // Navbar Scroll Behavior — removed (F12)
        // =========================
        // This was a second, unthrottled copy of the handler that custom.js
        // already registers on every page, so the homepage ran the same
        // scrollTop read and the same class writes twice per scroll event.
        // custom.js now owns it, coalesced into one requestAnimationFrame per
        // frame and attached as a passive listener.

        // =========================
        // Counter Animation — removed (F2)
        // =========================
        // Bound to .count-numbers, which no template in the app renders, so it
        // never fired. Removed together with the jquery.waypoints and
        // jquery.animateNumber <script> tags in public/index.html.

        // =========================
        // Jarallax Plugin
        // =========================
        if ($(".jarallax").length) {
          $(".jarallax").jarallax({ speed: 0.2 });
        }

        // =========================
        // Accordion Toggle
        // =========================
        $(".btn-link[aria-expanded='true']").closest(".accordion-item").addClass("active");
        $(".collapse").on("show.bs.collapse", function () {
          $(this).closest(".accordion-item").addClass("active");
        });
        $(".collapse").on("hidden.bs.collapse", function () {
          $(this).closest(".accordion-item").removeClass("active");
        });

        // =========================
        // Logo Carousel
        // =========================
        $(".customer-logos").slick({
          slidesToShow: 6,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 1500,
          arrows: false,
          dots: false,
          pauseOnHover: false,
          responsive: [
            { breakpoint: 768, settings: { slidesToShow: 4 } },
            { breakpoint: 520, settings: { slidesToShow: 3 } },
          ],
        });

        // =========================
        // Accordion Header Click Toggle
        // =========================
        document.querySelectorAll(".accordion-header").forEach((btn) => {
          btn.addEventListener("click", () => {
            const item = btn.parentElement;
            const openItem = document.querySelector(".accordion-item.active");
            if (openItem && openItem !== item) openItem.classList.remove("active");
            item.classList.toggle("active");
          });
        });

        // =========================
        // Hover Focus Effect
        // =========================
        const links = $(".js-hover-focus-one .service-sm");
        links
          .mouseenter(function () {
            links.addClass("unfocus");
            $(this).removeClass("unfocus");
          })
          .mouseleave(function () {
            $(this).removeClass("unfocus");
            links.removeClass("unfocus");
          });
      });
    }
  }
};
</script>
<style>
  /* .zsiq-flexM, .zsiq-iflexM {
    display: block !important;
  } */
</style>